/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Error } from '../../models/error';

export interface SetSubscriptionSubServiceActiveState$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The object ID. Must be a valid ID.
 */
  serviceUid: string;

/**
 * Active state the sub service should be set to
 */
  active: boolean;
}

export function setSubscriptionSubServiceActiveState(http: HttpClient, rootUrl: string, params: SetSubscriptionSubServiceActiveState$Params, context?: HttpContext): Observable<StrictHttpResponse<Error>> {
  const rb = new RequestBuilder(rootUrl, setSubscriptionSubServiceActiveState.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('serviceUid', params.serviceUid, {});
    rb.query('active', params.active, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Error>;
    })
  );
}

setSubscriptionSubServiceActiveState.PATH = '/subscriptions/{uid}/sub-service/{serviceUid}/activation';
